import { render, staticRenderFns } from "./SubGalleryNav.vue?vue&type=template&id=fc66c4fa&scoped=true&"
import script from "./SubGalleryNav.vue?vue&type=script&lang=js&"
export * from "./SubGalleryNav.vue?vue&type=script&lang=js&"
import style0 from "./SubGalleryNav.vue?vue&type=style&index=0&id=fc66c4fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc66c4fa",
  null
  
)

export default component.exports